import { Fragment, useState, useEffect } from 'react';
import Cita from './components/Cita';
import Formulario from './components/Formulario';

function App() {
  //Verifica la existencia de valores en el localstorage
  let citasLocalStorage = JSON.parse(localStorage.getItem('citas'));
  if (!citasLocalStorage) {
    citasLocalStorage = [];
  }

  //state guardar cita
  const [citas, guardarCitas] = useState(citasLocalStorage);

  // funcion que lee nueva cita y las citas existentes
  const crearCita = (cita) => {
    guardarCitas([...citas, cita]);
  };

  // funcion que permite realizar operaciones cuando el state cambie
  useEffect(() => {
    console.log('Algo paso con el state!!');
    if (citasLocalStorage) {
      console.log('Wntra');
      localStorage.setItem('citas', JSON.stringify(citas));
    }
  }, [citas]);

  // Funcion que elimina cita
  const eliminarCita = (cita) => {
    console.log('id: ' + cita.id);
    const citasFitrado = citas.filter(
      (citaFiltrado) => citaFiltrado.id !== cita.id
    );
    guardarCitas(citasFitrado);
  };

  // Mensaje de titulo de administracion de citas
  const tituloCitas =
    citas.length === 0 ? 'No hay citas' : 'Administre sus citas';

  return (
    <Fragment>
      <h1>Administrador de Pacientes</h1>

      <div className='container'>
        <div className='row'>
          <div className='one-half column'>
            <Formulario crearCita={crearCita}></Formulario>
          </div>
          <div className='one-half column'>
            <h2>{tituloCitas}</h2>
            {citas.map((cita) => (
              <Cita
                key={cita.id}
                cita={cita}
                eliminarCita={eliminarCita}
              ></Cita>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default App;
